import { render } from "./index.vue?vue&type=template&id=6afa3d2c"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/design/components/organisms/transition-type-selector/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6afa3d2c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6afa3d2c', __exports__)) {
    api.reload('6afa3d2c', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=6afa3d2c", () => {
    api.rerender('6afa3d2c', render)
  })

}


export default __exports__